import { define } from 'superstruct';
export const PASSWORD_MIN_LENGTH = 8;

/**
 * Ensure that a value is a valid password.
 */
export const password = ({
  allowEmpty = false
} = {}) => define('password', (value, context) => {
  const createError = message => ({
    message,
    ...context
  });
  if (typeof value !== 'string') {
    throw new TypeError('Password must be a string');
  }
  if (allowEmpty && value === '') {
    return true;
  }
  if (value.length < PASSWORD_MIN_LENGTH) {
    return createError('validations:Password Length');
  }
  if (/^\s|\s$/gu.test(value)) {
    return createError('validations:Password Whitespace');
  }
  if (!/[^A-Za-z]/gu.test(value) || !/[A-Za-z]/gu.test(value)) {
    return createError('validations:Password Complexity');
  }
  return true;
});